import {InjectionToken} from '@angular/core'

export interface IEnvironment {
  // Start with this, add more if needed.
  production: boolean
}

export const ENVIRONMENT = new InjectionToken<IEnvironment>('environment')

/**
 * Defines and exports an injection token that replaces the browser
 * window object.
 */
export const WINDOW = new InjectionToken<Window>('window')

